import { FormProvider } from 'react-hook-form';

import { QuestionLibraryStoreProvider } from '../store/QuestionLibraryStoreProvider';

type QuestionLibraryProvidersComponentProps = {
  methods?: any;
  screenData?: any;
  children?: React.ReactNode;
  shouldUpdateScreenData?: boolean;
};

/**
 * @typedef {object} FormProviderComponentProps
 * @property {object} methods - The react-hook-form methods
 * @property {import('./../types/common').QuestionLibraryScreenData} screenData - The screen data object needed for the form
 * @property {import('react').ReactNode} children - The children components
 *
 * @param {FormProviderComponentProps} props
 * @returns {JSX.Element}
 */
export default function QuestionLibraryProvidersComponent({
  screenData,
  children,
  methods,
  shouldUpdateScreenData = false,
}: Readonly<QuestionLibraryProvidersComponentProps>) {
  return (
    <QuestionLibraryStoreProvider
      screenData={screenData}
      shouldUpdateScreenData={shouldUpdateScreenData}
    >
      <FormProvider {...methods}>{children}</FormProvider>
    </QuestionLibraryStoreProvider>
  );
}
